import { useContext } from "react"
import { LoadStateContext } from "@/services/LoadStateContext";

export const useLoading = (scope: string = "") => {
	const { isLoading, scopes } = useContext(LoadStateContext);

	if (scope === "") {return [ isLoading, false, isLoading ];}
	return [isLoading, scopes[scope], isLoading && !scopes[scope]];
}
